function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 1rem 0;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  animation: spin 1s linear infinite;\n  color: var(--theme-primary, #3b82f6);\n  width: 1.5rem;\n  height: 1.5rem;\n  \n  @keyframes spin {\n    from {\n      transform: rotate(0deg);\n    }\n    to {\n      transform: rotate(360deg);\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  color: var(--theme-error-text, #b91c1c);\n  background-color: var(--theme-error-background-faint, #fef2f2);\n  border: 1px solid var(--theme-error-border, #fecaca);\n  padding: 1rem;\n  border-radius: 0.5rem;\n  margin: 1rem;\n  text-align: center;\n"
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 2rem 1rem;\n  margin: 1rem;\n  border: 1px dashed var(--theme-border, #e5e7eb);\n  border-radius: 0.5rem;\n  background-color: var(--theme-background-light, #f9fafb);\n  text-align: center;\n"
    ]);
    _templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
import React from 'react';
import styled from '@emotion/styled';
// Lucide React 직접 import - Vite 번들링 최적화 및 초기화 순서 문제 해결
import { Loader2 } from 'lucide-react';
// 로딩 인디케이터 스타일
var LoaderContainer = styled.div(_templateObject());
var SpinningLoaderWrapper = styled.div(_templateObject1());
var SpinningLoader = function() {
    return /*#__PURE__*/ React.createElement(SpinningLoaderWrapper, null, /*#__PURE__*/ React.createElement(Loader2, {
        style: {
            width: '100%',
            height: '100%'
        }
    }));
};
// 에러 메시지 스타일
var ErrorContainer = styled.div(_templateObject2());
// 빈 상태 스타일
var EmptyStateContainer = styled.div(_templateObject3());
// 무한 스크롤 리스트 컴포넌트
function InfiniteScrollList(param) {
    var items = param.items, renderItem = param.renderItem, _param_isLoading = param.isLoading, isLoading = _param_isLoading === void 0 ? false : _param_isLoading, _param_isFetchingNextPage = param.isFetchingNextPage, isFetchingNextPage = _param_isFetchingNextPage === void 0 ? false : _param_isFetchingNextPage, _param_error = param.error, error = _param_error === void 0 ? null : _param_error, _param_hasNextPage = param.hasNextPage, hasNextPage = _param_hasNextPage === void 0 ? false : _param_hasNextPage, fetchNextPage = param.fetchNextPage, observerRef = param.observerRef, _param_emptyStateContent = param.emptyStateContent, emptyStateContent = _param_emptyStateContent === void 0 ? '항목이 없습니다.' : _param_emptyStateContent, className = param.className, wrapperClassName = param.wrapperClassName, itemClassName = param.itemClassName;
    // 초기 로딩 상태
    if (isLoading && items.length === 0) {
        return /*#__PURE__*/ React.createElement(LoaderContainer, {
            className: className
        }, /*#__PURE__*/ React.createElement(SpinningLoader, null));
    }
    // 오류 상태
    if (error) {
        return /*#__PURE__*/ React.createElement(ErrorContainer, {
            className: className
        }, "오류가 발생했습니다: ", error.message);
    }
    // 빈 상태
    if (items.length === 0) {
        return /*#__PURE__*/ React.createElement(EmptyStateContainer, {
            className: className
        }, emptyStateContent);
    }
    return /*#__PURE__*/ React.createElement("div", {
        className: className
    }, /*#__PURE__*/ React.createElement("div", {
        className: wrapperClassName
    }, items.map(function(item, index) {
        return /*#__PURE__*/ React.createElement("div", {
            key: index,
            className: itemClassName
        }, renderItem(item));
    })), observerRef && /*#__PURE__*/ React.createElement("div", {
        ref: observerRef,
        style: {
            height: '100px',
            margin: '2rem 0',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            border: hasNextPage ? '1px dashed var(--theme-border, #e5e7eb)' : 'none',
            borderRadius: '8px',
            padding: '1rem',
            backgroundColor: hasNextPage ? 'var(--theme-background-light, #f9fafb)' : 'transparent'
        },
        "data-testid": "infinite-scroll-observer"
    }, isFetchingNextPage ? /*#__PURE__*/ React.createElement(LoaderContainer, null, /*#__PURE__*/ React.createElement(SpinningLoader, null), /*#__PURE__*/ React.createElement("div", {
        style: {
            marginLeft: '0.5rem'
        }
    }, "로딩 중...")) : hasNextPage ? /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", {
        style: {
            fontSize: '0.9rem',
            color: 'var(--theme-text-secondary)',
            marginBottom: '0.5rem'
        }
    }, "더 많은 항목이 있습니다"), /*#__PURE__*/ React.createElement("button", {
        onClick: fetchNextPage,
        style: {
            padding: '0.5rem 1rem',
            backgroundColor: 'var(--theme-primary, #3b82f6)',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer',
            fontSize: '0.9rem',
            fontWeight: '500'
        }
    }, "더 보기")) : null), !hasNextPage && items.length > 0 && !isFetchingNextPage && /*#__PURE__*/ React.createElement("div", {
        style: {
            textAlign: 'center',
            padding: '1rem',
            color: 'var(--theme-text-secondary)',
            fontSize: '0.9rem'
        }
    }, "모든 항목을 불러왔습니다."));
}
export default InfiniteScrollList;
